import React, { useId } from 'react';

export default function ModuleIntegrationUpdateChoice({ template, onChoose, onCancel }) {
  const headingId = useId();
  const missingDescriptionId = useId();
  const replaceDescriptionId = useId();

  return (
    <section aria-labelledby={headingId} className="space-y-5">
      <div>
        <h2 id={headingId} className="text-xl font-semibold text-slate-900">
          Atualizar integração
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          Integração selecionada: <strong className="text-slate-900">{template.name}</strong>
        </p>
      </div>

      <div className="space-y-3">
        <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
          <p id={missingDescriptionId} className="mb-3 text-sm text-slate-700">
            Preserva os campos, grupos e configurações atuais e adiciona somente campos e colunas que faltam.
          </p>
          <button
            type="button"
            aria-describedby={missingDescriptionId}
            className="w-full rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            onClick={() => onChoose('missing')}
          >
            Adicionar somente o que falta
          </button>
        </div>

        <div className="rounded-xl border border-red-200 bg-red-50 p-4">
          <p id={replaceDescriptionId} className="mb-3 text-sm text-slate-700">
            Substitui os campos e grupos atuais pelos da integração selecionada. As personalizações desses campos e grupos serão perdidas.
          </p>
          <button
            type="button"
            aria-describedby={replaceDescriptionId}
            className="w-full rounded-lg border border-red-300 bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            onClick={() => onChoose('replace')}
          >
            Substituir tudo do zero
          </button>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600"
          onClick={onCancel}
        >
          Cancelar
        </button>
      </div>
    </section>
  );
}
